<template>
	<inertia-head title="Special Discounted Offer - Account Expired" />

	<h2>Welcome back {{ user.fname }}!</h2>
	<div class="block-rounded">
		<div class="block-header text-center">
			<h3 class="block-title">CURRENT SUBSCRIPTION</h3>
		</div>
		<div class="block-content bg-primary-light text-center">
			<div class="h3 fw-bold mb-0">
				{{ user.current_rank }} {{ user.add_alias }}
			</div>
			<div>Expired at {{user.expiry_format}}</div>
			<div class="fs-sm fw-semibold mb-3">
				{{membership_type}}
			</div>
		</div>
	</div>
	<div v-if="specialCodeData.status=='Expired' || countdown_time_left<=0" class="text-center">
		<p class="h2 my-5 text-danger">The special one time discount for you has already expired.</p>
		<p class="h4 my-5">Do you still want to claim this discount? Click the button below.</p>
		<button @click="activateNow" type="button" class="btn btn-xl btn-info" :disabled="formActivate.processing">
			
			<span v-if="!formActivate.processing"><i class="fa fa-hourglass-half me-2"></i>Claim Exclusive Discount</span>
			<span v-else>
				<div class="spinner-border spinner-border-sm text-dark" role="status" >
					<span class="sr-only mr-1">Please wait...</span>
				</div>
				<span class="mx-2">Please wait...</span>
			</span>
		</button>
		<inertia-link
			v-if="!form.processing"
			:href="route('post.logout')"
			method="post"
			as="button"
			class="btn btn-alt-secondary ms-3"
		>
			Logout
		</inertia-link>
	</div>
	<div v-else>
		
		<p v-if="countdown_done==false" class="text-center mt-4">
			<span class="h4">TIME LEFT</span>
			<div class="h1">{{countdown_display}}</div>
		</p>
		<p class="text-center h3 my-5 text-danger">Grab this special one time discount for you. Please note that this offer will expire in 24 hours, so don't wait too long to take advantage of it.</p>
		<p class="text-center my-5">Please choose your membership plan below to start enjoying your TRC benefits.</p>
		<form @submit.prevent="specialRenew">
			<div class="row">
				<div class="col-md-6 mb-4">
					<div v-if="form.errors.subscription" class="alert alert-danger">
						<p class="fw-semibold mb-0">{{ form.errors.subscription }}</p>
					</div>
					<div class="row">
						<div class="col-12">
							<p class="fw-bold mb-1">Choose Subscriptions</p>
							<div
								v-for="(collections, index) in products"
								:key="index"
								class="block block-rounded"
							>
								<div class="block-header block-header-default">
									<h3 class="block-title">
										{{ collections[0].alias }}
										{{ collections[0].add_alias }}
									</h3>
								</div>
								<div class="block-content">
									<div class="row">
										<div
											class="col-12"
											v-for="subscription in collections"
											:key="subscription.prod_id"
										>
											<div class="form-check form-block mb-3">
												<input
													v-model="form.subscription"
													class="form-check-input"
													type="radio"
													:value="subscription.prod_id"
													:id="subscription.prod_id"
													name="subscription"
												/>
												<label class="form-check-label" :for="subscription.prod_id">
													<span class="d-flex align-items-center">
														<h6 class="fs-sm mb-0">
															{{ subscription.membership }}
														</h6>
													</span>
													<small>
														<span v-if="subscription.discounted_amount!=0">
															<s class="text-muted"> &#8369;{{ subscription.amount }} </s>
															<span class="text-danger"> &#8369;{{ subscription.discounted_amount }} </span>
														</span>
														<span v-else> &#8369;{{subscription.amount}}</span>
														<span v-if="subscription.add_display" class="badge bg-warning ms-1">
															{{ subscription.add_display }}
														</span>
													</small>
												</label>
											</div>
										</div>
									</div>
								</div>
							</div>	
						</div>
						<!-- <div
							class="col-12"
							v-for="(subscription,index) in products"
							:key="subscription.prod_id"
						>
							<div class="form-check form-block mb-3">
								<input
									v-model="form.subscription"
									class="form-check-input"
									type="radio"
									:value="subscription.prod_id"
									:id="subscription.prod_id"
									name="subscription"
								/>
								<label class="form-check-label" :for="subscription.prod_id">
									<span class="d-flex align-items-center">
										<h6 class="fs-sm mb-0">
											{{ subscription.membership }}
										</h6>
										<span
											v-if="subscription.add_display"
											class="badge bg-warning ms-1"
										>
											{{ subscription.add_display }}
										</span>
									</span>
									<small>&#8369;{{ subscription.amount }}</small>
								</label>
							</div>
						</div> -->
					</div>
				</div>
				<div class="col-md-6 mb-4">
					<h6 class="fw-semibold">Choose Payment Method</h6>
					<div class="row">
						<div class="col-6">
							<div class="form-check form-block mb-4">
								<input
									v-model="form.payment_method"
									class="form-check-input"
									type="radio"
									value="CARD"
									id="card"
									name="payment_method"
								/>
								<label class="form-check-label" for="card">
									<span
										class="d-flex align-items-center"
										style="
											background-image: url(/media/logo/stripe-logo.png);
											background-size: contain;
											background-repeat: no-repeat;
											background-position: center;
											height: 80px;
										"
									>
									</span>
								</label>
							</div>
						</div>
						<div v-if="payment_available==true" class="col-6">
							<div class="form-check form-block mb-4">
								<input
									v-model="form.payment_method"
									class="form-check-input"
									type="radio"
									:value="'DRAGONPAY'"
									id="dragonpay"
									name="payment_method"
								/>
								<label class="form-check-label" for="dragonpay">
									<span
										class="d-flex align-items-center"
										style="
											background-image: url(/media/logo/dragonpay.png);
											background-size: contain;
											background-repeat: no-repeat;
											background-position: center;
											height: 80px;
										"
									>
									</span>
								</label>
							</div>
						</div>
						<div v-if="payment_available==true" class="col-6">
							<div class="form-check form-block mb-4">
								<input
									v-model="form.payment_method"
									class="form-check-input"
									type="radio"
									:value="'DRAGONPAY-GCASH'"
									id="dragonpay_gcash"
									name="payment_method"
								/>
								<label class="form-check-label" for="dragonpay_gcash">
									<span
										class="d-flex align-items-center"
										style="
											background-image: url(/media/logo/gcash.png);
											background-size: contain;
											background-repeat: no-repeat;
											background-position: center;
											height: 80px;
										"
									>
									</span>
								</label>
							</div>
						</div>
						<!-- <div class="col-4">
							<div class="form-check form-block mb-4">
								<input
									v-model="form.payment_method"
									class="form-check-input"
									type="radio"
									:value="'BROPAY'"
									id="bropay"
									name="payment_method"
								/>
								<label class="form-check-label" for="bropay">
									<span
										class="d-flex align-items-center"
										style="
											background-image: url(/media/logo/bropay-logo.png);
											background-size: contain;
											background-repeat: no-repeat;
											background-position: center;
											height: 80px;
										"
									>
									</span>
								</label>
							</div>
						</div> -->
					</div>
					<div v-if="form.payment_method == 'CARD'">
						<div v-if="has_card">
							<div class="form-check form-switch mb-4">
								<input
									v-model="form.use_existing_card"
									class="form-check-input"
									type="checkbox"
									:value="true"
									id="example-switch-default1"
									name="example-switch-default1"
								/>
								<label class="form-check-label" for="example-switch-default1">
									Use existing card
								</label>
							</div>
							<div v-if="form.use_existing_card" class="mb-4">
								<p class="mb-0">
									<span class="fw-semibold">CARD:</span>
									<i>**** **** **** {{ card.last4 }}</i>
									<span class="badge bg-primary ms-2">{{ card.brand }}</span>
								</p>
							</div>
						</div>
						<div v-if="!form.use_existing_card" class="form-group mb-4">
							<stripe @accept-token="acceptToken" ref="stripe" />
							<div v-if="form.errors.card" class="invalid-feedback d-block">
								<i class="fa fa-exclamation-circle"></i>
								{{ form.errors.card }}
							</div>
						</div>
					</div>
					<div class="mb-4 text-end space-x-1">
						<inertia-link
							v-if="!form.processing"
							:href="route('post.logout')"
							method="post"
							as="button"
							class="btn btn-alt-secondary"
						>
							Logout
						</inertia-link>
						<button
							class="btn btn-alt-primary"
							:disabled="
								form.processing ||
								!form.subscription ||
								(form.payment_method === 'CARD' &&
									!form.use_existing_card &&
									!form.token)
							"
						>
							
							<span v-if="!form.processing">Renew Now!</span>
							<span v-else>
								<div class="spinner-border spinner-border-sm text-dark" role="status" >
									<span class="sr-only mr-1">Please wait...</span>
								</div>
								<span class="mx-2">Please wait...</span>
							</span>
						</button>
					</div>
				</div>
			</div>
		</form>
	</div>
</template>

<script>

window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());

gtag('config', window.gtag_id);

import { useForm } from '@inertiajs/inertia-vue3'
import GuestLayout from '../../Layouts/GuestLayout'
import Stripe from '../../Shared/Components/Stripe'
import { watch, ref } from 'vue'
import { Inertia } from '@inertiajs/inertia'
import { createToaster } from '@meforma/vue-toaster'

export default {
	layout: GuestLayout,
	props: {
		user: Object,
		specialCodeData: Object,
		membership_type: String,
		test: String,
		products: Object,
		has_card: Boolean,
		card: Object,
		flash: Object,
		rebates: Object,
	},
	components: {
		Stripe,
	},
	setup(props) {
		const toast = createToaster();

		const payment_available = ref(true);

		const countdown_time_left = ref(0);
		const countdown_done 	= ref(false);
		const countdown_display = ref('00:00:00');

		const form = useForm({
						subscription 		: null,
						payment_method		: 'CARD',
						pmethod				: null,
						pchannel			: null,
						token 				: null,
						use_existing_card	: props.has_card?true:false,
						action 				: 'renew',
						rebates 			: props.rebates,
						special_code 		: props.specialCodeData.special_code,
						test 				: props.test
					})

		const formActivate = useForm({});

		const acceptToken = (token) => {
								form.token = token
							}


		const activateNow = () => {
						formActivate.put(route('account.put.special-discount-reactivation',{special_code:props.specialCodeData.special_code}), {
							only:['flash','products','specialCodeData'],
							onSuccess:()=>{
								startCountDown();
							}
						})
					}

		const specialRenew = () => {
						form.post(route('account.post.special-discount'), {
							preserveState: true,
							preserveScroll: false,
							only:['flash','user','products','specialCodeData'],
						})
					}

		const startCountDown = ()=>{
			countdown_done.value = false;
			countdown_time_left.value = props.specialCodeData.time_left;
			setTimeout(function(){
			    countdown_time_left.value--;
			},1000);
		}


		//START Special Discount Countdown
		if(Object.prototype.hasOwnProperty.call(props.specialCodeData,'special_code'))
		{
			startCountDown();
		}
		
		watch(countdown_time_left,(value,old_value)=>{

			var self = this;
			var hrs = 0, mins = 0, secs = 0;
			if (value>0 && value!=old_value) {

				hrs 	= Math.floor(countdown_time_left.value/60/60);
				mins 	= Math.floor(countdown_time_left.value/60);
				secs 	= value;

				secs 	= secs % 60;
				mins 	= mins % 60;
				hrs 	= hrs % 24;

				countdown_display.value = (hrs>9 ? hrs : "0" + hrs) + ":" + (mins>9 ? mins : "0" + mins) + ":" + (secs>9 ? secs : "0" + secs);

				setTimeout(function(){
				    countdown_time_left.value--;
				},1000);

			} else {
				countdown_display.value = "00:00:00";
				countdown_done.value = true;
			}

		})
		//END Special Discount Countdown

		watch(
			() => form.payment_method,
			(payment_method) => {
				
				form.pmethod 	= null;
				form.pchannel 	= null;	

				if(payment_method=='CARD' && props.has_card)
				{
					form.use_existing_card = true;
				}else{
					form.use_existing_card = false;
				}

				if(payment_method!='CARD')
				{
					form.token = null;

					if(payment_method=='DRAGONPAY-GCASH')
					{
						form.pmethod 	= 'GCASH';
						form.pchannel 	= 'GCSH';
					}

				}
			}
		)

		watch(
			() => form.use_existing_card,
			(use_existing_card) => {
				
				if(use_existing_card==true)
				{
					form.token = null;
				}
			}
		)

		watch(()=>form.subscription,(value)=>{
			let val = value.split('+');
			if(value && val[0].includes("1M"))
			{
				form.payment_method = 'CARD';
				payment_available.value = false;

				form.pmethod 	= null;
				form.pchannel 	= null;	

			}else
			{
				payment_available.value = true;
			}
		})

		return {
			toast,
			countdown_display,
			countdown_time_left,
			countdown_done,
			form,
			formActivate,
			startCountDown,
			activateNow,
			specialRenew,
			payment_available,
			acceptToken,
		}
	},
}
</script>
